import useAuth from "../modules/auth/hooks";
import React, { useRef, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  FormInput,

  ListGroup,
  ListGroupItem,
  Row
} from "shards-react";

function Auth() {
  const [userid, setUserid] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const idInput = useRef(null);
  const passwordInput = useRef();
  const useridChange = e => {
    const {
      target: { value }
    } = e;
    setUserid(value);
  };
  const passwordChange = e => {
    const {
      target: { value }
    } = e;
    setPassword(value);
  };
  const loginValidateCheck = () => {
    if (!userid) {
      window.alert('아이디를 입력해주세요.')
      console.log('foucs Test:', idInput.current, userid)
      idInput.current.focus()
      return false;
    }

    if (!password) {
      window.alert("비밀번호를 입력해주세요.")
      console.log(passwordInput.current)
      passwordInput.current.focus()
      return false;
    }
    return true;
  }
  const onLogin = () => {
    const validate = loginValidateCheck()

    validate && login({ userid, password }).then().catch(error => {
      console.log(error);
    })
  };
  const onEnterPress = (e) => {
    if (e.key === 'Enter') {
      onLogin()
    }
  }
  return (
    <Container className="px-4 pb-4" style={{
      height: "100%",
      marginTop: "18%",
      width: "500px",
      position: 'relative'
    }}>
      <Card small className="mb-4">
        <CardHeader className="border-bottom">
          <img
            // style={{position:'absolute', top: -60,  width: 200}}
            id="main-logo"
            className="d-inline-block align-top"
            // style={{ maxWidth: "25px" }}
            src={require("../images/icon-logo.svg")}
            alt="UseB.관리자"
          />

        </CardHeader>
        <ListGroup flush>
          <ListGroupItem className="p-3">
            <Row>
              <Col>
                {/* <Container> */}
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <label htmlFor="feFirstName">아이디</label>
                    <FormInput
                      id="feFirstName"
                      placeholder="아이디나 이메일을 입력해주세요"
                      value={userid}
                      onChange={useridChange}
                      ref={idInput}
                      onKeyPress={onEnterPress}
                    />
                  </Col>
                </Row>
                <Row form>
                  <Col md="12" className="form-group">
                    <label htmlFor="fePassword">비밀번호</label>
                    <FormInput
                      type="password"
                      id="fePassword"
                      placeholder="비밀번호를 입력해주세요"
                      value={password}
                      onChange={passwordChange}
                      onKeyPress={onEnterPress}
                      ref={passwordInput}
                      autoComplete="current-password"
                    />
                  </Col>
                </Row>
                <Row form>
                  <Col md="12">
                    {/* <Button onClick={onSubmit} theme="accent">
                      Register
                    </Button> */}
                    <Button onClick={onLogin} className="w-100 ml-auto mt-3" theme="accent">
                      Login
                    </Button>
                  </Col>
                </Row>
                {/* </Container> */}
              </Col>
            </Row>
          </ListGroupItem>
        </ListGroup>
      </Card>
    </Container>
  );
}

export default Auth;
